import axios from "@/api/axiosInstance";
import {
  DataEnvelope,
  Enrollment,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Mark a module complete for the caller's own active enrollment. Returns the
// recomputed enrollment (progress + status).
export const completeModule = async (
  moduleUuid: string,
): Promise<Enrollment> => {
  const response = await axios.post<DataEnvelope<Enrollment>>(
    `/api/private/learning-center/modules/${moduleUuid}/complete`,
  );
  return response.data.data;
};
